export const routeMap = {
  logging: 'logging',
  person: 'persoon',
  messages: 'documentendienst',
  led: 'leer_en_ervaring',
  mobility: 'mobiliteit',
  healthattestations: 'attesten',
  reporting: 'rapportering',
  docprovider: 'documentendienstaansluitingen',
  socialsecurity: 'socialezekerheid',
  landregistry: 'kadaster',
  family: 'gezin',
  company: 'onderneming',
  education: 'onderwijs',
  work: 'werk',
  income: 'inkomen',
}
